<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 [langkey]="availableServiceTitle"></h2>
    <div>
      <div class="availableService_content" [langkey]="availableServiceContent"></div>
    </div>
    <div class="availableservice-opentime">
      <h3 [langkey]="serviceOpenTimeTitle"></h3>
      <ng-container *ngIf="data.isLocationOpen; then openTimeTemplate else openDaysTemplate"></ng-container>
      <ng-template #openTimeTemplate>
        <div class="location-detail-opentime">
          <div class="times">{{openDays[0].timesToString()}}</div>
        </div>
      </ng-template>
      <ng-template #openDaysTemplate>
        <div class="location-openday ya-body-1">
          <ng-container *ngFor="let openday of openDays; let first = first">
            <div class="weekday" [class.item--highlight]="first">{{openday.weekdayToString()}}:</div>
            <p [class.item--highlight]="first">{{openday.timesToString()}}</p>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <div class="ya-button-container">
      <button a11y_Button mat-flat-button (click)="routeToLocation()"><span langkey="phGlobal_Continue"></span></button>
    </div>
  </div>
</div>